import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
	title: Yup.string().required().label('Title'),
	message: Yup.string().required().label('Message'),

});

const Inputs = [
	{
		name: 'title',
		label: 'Title',
		type: 'text',
		value: 'single',
		valueAttr: 'title',
		required: true,
	},
	{
		name: 'message',
		label: 'Message',
		type: 'textarea',
		value: 'single',
		valueAttr: 'message',
		required: true,
	}

];

export { Inputs, validationSchema };
